import { AlertTypes } from '../util/Constant.js';
import i18n from '../localization/i18n';
import ApiEngine from "../util/ApiEngine.js";
import { ApiUrl, ApiKey, SessionKey } from "../util/Constant";
import { numberWithCurrencyFormat, stringIsNullOrEmpty } from "../util/Util";

export const _BIND_MEMBER = "bindMember";
export const _BUSY = 'busy';
export const _IDLE = 'idle';
export const _API_CALLED = 'setApiCalled';
export const _DOWNLINE_SEARCH = 'setDownlineSearchTextCalled';
export const _DOWNLINE_QUERY = 'setDownlineQueryCalled';
export const _GAME_SEARCH = 'setGameSearchTextCalled';
export const _GAME_QUERY = 'setGameQueryCalled';
export const _SET_Y = "setY";
export const _SET_PAGESIZE = "setPageSize";
export const _SET_ACTIVE_TAB = "setActiveTab";
export const _IS_KEEPED_LOGIN = "userKeepLogin";
export const _IS_SHOW_LOGIN = "isShowLogin";
export const _IS_SHOW_REGISTER = "isShowRegister";
export const _IS_SHOW_FORGOT_PASSWORD = "isShowForgotPassword";
export const _IS_SHOW_CREATE_SHARE_HOLDER_PIN = "isShowCreateShareHolderPin";
export const _IS_SHOW_CREATE_SHARE_HOLDER_PIN_POPUP = "isShowCreateShareHolderPinPopup";
export const _IS_SHOW_VERIFY_SHARE_HOLDER_PIN = "isShowVerifyShareHolderPin";
export const _IS_SHOW_COMMUNICATION_CHANNEL = "isShowCommunicationChannel";
export const _COMMUNICATION_CHANNEL_LIST = "communicationChannelList";
export const _RTP_URL = "rtpUrl";
export const _IS_SHOW_PROFILE = "isShowProfile";
export const _IS_NON_SEAMLESS_GAME_EXIST = "isNonSeamlessGameExist";
export const _CHECK_DAILY_CHECK_IN = "setDailyChecking";
export const _BANNER_POPUP_MODAL = "bannerPopupModal";
export const _BANNER_POPUP_IMAGE = "bannerPopupImage";
export const _PRODUCT_CATEGORY_GAME_LIST = "setProductCategoryGameList";
export const _UNCLAIM_COMMISSION = "unclaimCommission";
export const _GRAND_TOTAL_REWARDS = "grandTotalRewards";
export const _GAME_POINTS = "gamePoints";
export const _GAMES_93_CONNECT = "games93Connect";
export const _UNREAD_NOTIFICATION = "unreadNotification";
export const _IS_SHOW_BIG_WINNING = "isShowBigWinning";
export const _IS_PLATINUM = "isPlatinum";
export const _SET_TELEGRAM_BOT_STATUS = 'setTelegramBotStatus';
export const _SET_TELEGRAM_BANNER_SECONDARY = 'setTelegramBannerSecondary';
export const _ANGPAO_STATUS = "angpaoStatus";
export const _SHOW_ANGPAO_TNC = "showAngpaoTnc";
export const _FIFA_STATUS = "fifaStatus";
export const _FREE_SPIN_COUNT = "freeSpinCount";

export const _ALERT_TYPES = {
    SET_ALERT: 'SetAlert',
    NONE: 'AlertNone',
}

export const setY = (y) => {
    return (dispatch) => {
        dispatch({
            type: _SET_Y,
            y,
        });
    };
};

export const bindMember = async (dispatch) => {
    let member = [];
    let balance = 0;

    let responseJson = await ApiEngine.get(ApiUrl._API_GET_MEMBER_DETAILS_BY_ID);
    if (!responseJson[ApiKey._API_SUCCESS_KEY]) {
        dispatch(showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY]));
        throw responseJson[ApiKey._API_MESSAGE_KEY];
    }

    member = responseJson[ApiKey._API_DATA_KEY];
    balance = isNaN(parseFloat(member["primaryCredit"]), 3) ? "0.00" : numberWithCurrencyFormat(parseFloat(member["primaryCredit"]), 2, true);

    dispatch({
        type: _BIND_MEMBER,
        member: member,
        walletBalance: balance,
    });
};

export const setPageSize = (pagesize) => {
    return (dispatch) => {
        dispatch({
            type: _SET_PAGESIZE,
            data: pagesize,
        });
    };
};


export const setDailyChecking = (isCheckedIn) => {
    return (dispatch) => {
        dispatch({
            type: _CHECK_DAILY_CHECK_IN,
            data: isCheckedIn,
        });
    };
};

export const setActiveTab = (activeTab) => {
    return (dispatch) => {
        dispatch({
            type: _SET_ACTIVE_TAB,
            data: activeTab,
        });
    };
};

export const userKeepLogin = (isKeepedLogin) => {
    return (dispatch) => {
        dispatch({
            type: _IS_KEEPED_LOGIN,
            data: isKeepedLogin,
        });
    };
};

export const setDownlineSearchText = (e) => {
    return async dispatch => {
        dispatch({
            type: _DOWNLINE_SEARCH,
            data: e
        });
    }
}

export const setDownlineQuery = (e) => {
    return async dispatch => {
        dispatch({
            type: _DOWNLINE_QUERY,
            data: e
        });
    }
}

export const setGameSearchText = (e) => {
    return async dispatch => {
        dispatch({
            type: _GAME_SEARCH,
            data: e
        });
    }
}

export const setGameQuery = (e) => {
    return async dispatch => {
        dispatch({
            type: _GAME_QUERY,
            data: e
        });
    }
}

/// <summary>
/// Author : 
/// </summary>
export const setBusy = (iconEnabled, message) => {
    return async dispatch => {
        dispatch({
            type: _BUSY,
            message: message,
            iconEnabled: iconEnabled
        });
    }
}

/// <summary>
/// Author : 
/// this function is to only update user status to logout
/// </summary>
export const setIdle = () => {
    return async dispatch => {
        dispatch({
            type: _IDLE
        });
    }
}

/// <summary>
/// Author : 
/// </summary>
export const setPerformApiCall = (status, url) => {
    return async dispatch => {
        dispatch({
            type: _API_CALLED,
            data: { success: status, url: url }
        });
    }
}

/// <summary>
/// Author: -
/// </summary>
export const showResponseMessage = (status, message, translateRequired = true) => {
    return dispatch => {
        var messageToShow = message;
        if (translateRequired) {
            messageToShow = i18n.t(message);
        }
        if (stringIsNullOrEmpty(messageToShow)) {
            return;
        }
        let alertMode = status ? AlertTypes._SUCCESS : AlertTypes._ERROR;
        if (message == 'SESSION_EXPIRED' || message == 'FORCED_LOGOUT') {
            alertMode = AlertTypes._INFO;
        }
        dispatch(showMessage({ type: (alertMode), content: messageToShow }));
    }
}

/// <summary>
/// Author: -
/// </summary>
export const showResponseMessageWithoutT = (status, message, translateRequired = true) => {
    return dispatch => {
        var messageToShow = message;
        if (stringIsNullOrEmpty(messageToShow)) {
            return;
        }
        dispatch(showMessage({ type: (status ? AlertTypes._SUCCESS : AlertTypes._ERROR), content: messageToShow }));
    }
}


/// <summary>
/// Author: -
/// </summary>
export const showMessage = (alertProps) => {
    if (!alertProps || stringIsNullOrEmpty(alertProps.content)) {
        return () => {};
    }
    return dispatch => {
        const customConfirm = alertProps.onConfirm;
        alertProps.onConfirm = async (...args) => {
            disposeMessage()(await dispatch);
            if (customConfirm) {
                customConfirm(...args);
            }
        }

        const customCancel = alertProps.onCancel;
        alertProps.onCancel = async (...args) => {
            disposeMessage()(await dispatch);
            if (customCancel) {
                customCancel(...args);
            }
        }
        alertProps.cancelBtnBsStyle = 'danger';
        alertProps.title = alertProps.title ?? "";
        alertProps.allowEscape = false;
        alertProps.reverseButtons = true;
        dispatch({ type: _ALERT_TYPES.SET_ALERT, alert: alertProps });
    }
}

/// <summary>
/// Author: -
/// </summary>
export const disposeMessage = () => {
    return dispatch => {
        dispatch({ type: _ALERT_TYPES.NONE });
    }
}

export const setDisplayLogin = (e) => {
    return async dispatch => {
        dispatch({
            type: _IS_SHOW_LOGIN,
            data: e
        });
    }
}

export const setDisplayRegister = (e) => {
    return async dispatch => {
        dispatch({
            type: _IS_SHOW_REGISTER,
            data: e
        });
    }
}

export const setDisplayCommunicationChannel = (e) => {
    return async dispatch => {
        dispatch({
            type: _IS_SHOW_COMMUNICATION_CHANNEL,
            data: e
        });
    }
}

export const setCommunicationChannelList = (e) => {
    return async dispatch => {
        dispatch({
            type: _COMMUNICATION_CHANNEL_LIST,
            data: e
        });
    }
}

export const setDisplayForgotPassword = (e) => {
    return async dispatch => {
        dispatch({
            type: _IS_SHOW_FORGOT_PASSWORD,
            data: e
        });
    }
}

export const setIsShowCreateShareHolderPin = (e) => {
    return async dispatch => {
        dispatch({
            type: _IS_SHOW_CREATE_SHARE_HOLDER_PIN,
            data: e
        });
    }
}
export const setIsShowCreateShareHolderPinPopup = (e) => {
  return async dispatch => {
    dispatch({
      type: _IS_SHOW_CREATE_SHARE_HOLDER_PIN_POPUP,
      data: e
    });
  }
}


export const setIsShowVerifyShareHolderPin = (e) => {
    return async dispatch => {
        dispatch({
            type: _IS_SHOW_VERIFY_SHARE_HOLDER_PIN,
            data: e
        });
    }
}

export const setRtpUrl = (e) => {
    return async dispatch => {
        dispatch({
            type: _RTP_URL,
            data: e
        });
    }
}

export const setDisplayProfile = (e) => {
    return async dispatch => {
        dispatch({
            type: _IS_SHOW_PROFILE,
            data: e
        });
    }
}

export const setIsNonSeamlessGameExist = (e) => {
    return async dispatch => {
        dispatch({
            type: _IS_NON_SEAMLESS_GAME_EXIST,
            data: e
        });
    }
}

export const setBannerPopupModal = (e) => {
  return async dispatch => {
    dispatch({
      type: _BANNER_POPUP_MODAL,
      data: e
    });
  }
}

export const setBannerPopupImage = (e) => {
  return async dispatch => {
    dispatch({
      type: _BANNER_POPUP_IMAGE,
      data: e
    });
  }
}


export const setProductCategoryGameList = (e) => {
    return async dispatch => {
        dispatch({
            type: _PRODUCT_CATEGORY_GAME_LIST,
            data: e
        });
    }
}

export const setUnclaimCommission = (e) => {
  return async dispatch => {
      dispatch({
        type: _UNCLAIM_COMMISSION,
        data: e
      });
  }
}


export const setGrandTotalRewards = (e) => {
  return async dispatch => {
    dispatch({
      type: _GRAND_TOTAL_REWARDS,
      data: e
    });
  }
}

export const setGamePoints = () => {
  return async dispatch => {
    var responseJson = await ApiEngine.get(ApiUrl._API_GET_MEMBER_LOYALTY_POINTS_BY_ID);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      dispatch({
        type: _GAME_POINTS,
        data: responseJson[ApiKey._API_DATA_KEY],
      });
    }
  }
}

export const setGames93Connect = (e) => {
  return async dispatch => {
    dispatch({
      type: _GAMES_93_CONNECT,
      data: e
    });
  }
}

export const setUnreadNotification = (e) => {
  return async dispatch => {
    dispatch({
      type: _UNREAD_NOTIFICATION,
      data: e,
    });
  }
}


export const setUnreadNotificationApi = (e) => {
  return async dispatch => {
    var responseJson = await ApiEngine.get(
      ApiUrl._API_GET_UNREAD_NOTIFICATION_LIST + "?languageCode=" +
      (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
        localStorage.getItem(SessionKey._LANGUAGE) : 'id'));

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      dispatch({
        type: _UNREAD_NOTIFICATION,
        data: responseJson[ApiKey._API_DATA_KEY],
      });
    } else {
      dispatch({
        type: _UNREAD_NOTIFICATION,
        data: 0,
      });
    }
  }
}

export const setIsShowBigWinning = (e) => {
  return async dispatch => {
    dispatch({
      type: _IS_SHOW_BIG_WINNING,
      data: e
    });
  }
}

export const checkMemberDownlineDeposit = () => {
  return async dispatch => {
    let responseJson = await ApiEngine.get(ApiUrl._API_CHECK_DOWNLINE_DEPOSIT);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let isPlatinum = responseJson[ApiKey._API_DATA_KEY];

      dispatch({
        type: _IS_PLATINUM,
        data: isPlatinum
      })
    }
  }
}

export const handleTelegramBannerOnClick = () => {
  return async dispatch => {
    window.open("https://t.me/i8_indonesia_bot");
  }
}

export const setTelegramBotStatus = (e) => {
  return async dispatch => {
    dispatch({
      type: _SET_TELEGRAM_BOT_STATUS,
      data: e
    });
  }
}

export const setTelegramBannerSecondary = (e) => {
  return async dispatch => {
    dispatch({
      type: _SET_TELEGRAM_BANNER_SECONDARY,
      data: e
    });
  }
}

export const setAngpaoStatus = (e) => {
    return async dispatch => {
        dispatch({ type: _ANGPAO_STATUS, data: e });
    }
}

export const setShowAngpaoTnc = (e) => {
    return async dispatch => {
        dispatch({ type: _SHOW_ANGPAO_TNC, data: e });
    }
}

export const setFifaStatus = (e) => {
    return async dispatch => {
        dispatch({ type: _FIFA_STATUS, data: e });
    }
}

export const setFreeSpinCount = (e) => {
    return async dispatch => {
        dispatch({ type: _FREE_SPIN_COUNT, data: e });
    }
}